import { useLang } from "@/i18n";

// Apartment status with the same colours as the admin panel:
// green = bookable, yellow = coming soon, red = not available.
const LOOK = {
  available: "bg-green-600",
  comingSoon: "bg-amber-500",
  unavailable: "bg-red-600",
};

export default function UnitStatus({ unit, className = "" }) {
  const { t } = useLang();
  const key = unit.bookable ? "available" : unit.availabilityStatus === "comingSoon" ? "comingSoon" : "unavailable";
  const s = t.unitStatus[key];
  return (
    <p className={`flex items-center gap-2 text-sm ${className}`} data-testid={`unit-status-${unit.slug}`} data-status={key}>
      <span className={`h-2.5 w-2.5 shrink-0 rounded-full ${LOOK[key]}`} aria-hidden="true" />
      <span className="font-medium text-ink">{s.label}</span>
      <span className="text-stone">· {s.hint}</span>
    </p>
  );
}
